import CryptoJS from 'crypto-js';

const SECRET_KEY = import.meta.env.VITE_APP_SECRET_KEY || 'frontline-fallback-secret-key-2026';

export const SecureStorage = {
  setItem(key, value) {
    try {
      if (!value) return; // No guardar nulos
      const stringValue = JSON.stringify(value);
      const encrypted = CryptoJS.AES.encrypt(stringValue, SECRET_KEY).toString();
      localStorage.setItem(key, encrypted);
    } catch (e) {
      console.error('Error al encriptar:', e);
    }
  },

  getItem(key) {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;

      const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      // --- DIAGNÓSTICO ---
      if (!decryptedString) {
        console.error('❌ Error Crítico: La desencriptación devolvió una cadena vacía. Verifica tu SECRET_KEY.');
        return null;
      }
      // -------------------

      return JSON.parse(decryptedString);
    } catch (e) {
      // AQUÍ ESTÁ EL PROBLEMA: Vamos a ver qué error es
      console.error('❌ Error en SecureStorage.getItem:', e);

      // Opcional: Borrar el dato corrupto para evitar bucles
      localStorage.removeItem(key);
      return null;
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  }
};